import React, {Component} from 'react';
import {Table, Button} from 'reactstrap';
import './StaffList.css';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import PropTypes from 'prop-types';
import _ from 'lodash';
import CreateStaffMemberModal from "../staffMemberModal/createStaffMemberModal/CreateStaffMemberModal.container";
import RemoveStaffMemberModal from "../staffMemberModal/removeStaffMemberModal/RemoveStaffMemberModal.container";
import {sharedLabelsPath} from "../../../reducers/common/localization";
import ResendActivationStaffMember
    from '../staffMemberModal/resendActivationStaffMember/ResendActivationStaffMember.container';
import ChangeAnchorModal from "../changeAnchorModal/ChangeAnchorModal.container";
import PaginationStaff from "../../commonComponents/paginationComponent/PaginationStaff.container";

class StaffList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resendActivationEmail: null
        }
    }

    render() {
        return (
            <div className='staff-list-component-container'>
                <div className='staff-list-container'>
                    <h4 className='page-label'>{_.get(this.props.translation, 'org_staff.staff.table_label')}</h4>
                    {this.renderButtonsBar()}
                    <PaginationStaff/>
                    {this.renderContent()}
                    <CreateStaffMemberModal/>
                    <RemoveStaffMemberModal
                        onRemove={this.onStaffRemove}
                    />
                    <ResendActivationStaffMember email={this.state.resendActivationEmail}/>
                    <ChangeAnchorModal/>
                </div>
            </div>
        )
    }

    renderContent() {
        if (this.props.loading) {
            return (
                <div className="staff-list-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if (_.isNil(this.props.data) || this.props.data.length === 0) {
            return (
                <div className="staff-list-status-message-container">
                    <h5>{_.get(this.props.translation, 'org_staff.staff.no_data_label')}</h5>
                </div>
            );
        }
        return (
            <Table className='staff-list-table'>
                <thead>
                <tr>
                    <th>{_.get(this.props.translation, sharedLabelsPath.first_name_label)}</th>
                    <th>{_.get(this.props.translation, sharedLabelsPath.last_name_label)}</th>
                    <th>{_.get(this.props.translation, sharedLabelsPath.email_label)}</th>
                    <th/>
                </tr>
                </thead>
                <tbody>
                {this.renderStaffData()}
                </tbody>
            </Table>
        )
    }

    renderStaffData() {
        return _.map(this.props.data, (member, index) => (
            <tr key={index}
                className={!member.active ? 'not-active-staff-member-list-row' : ''}>
                <td className='first-name-td' data-th={_.get(this.props.translation, sharedLabelsPath.first_name_label) + ':'}>
                    {member.firstName}
                </td>
                <td className='last-name-td' data-th={_.get(this.props.translation, sharedLabelsPath.last_name_label) + ':'}>
                    {member.lastName}
                </td>
                <td className='email-td' data-th={_.get(this.props.translation, sharedLabelsPath.email_label) + ':'}>
                    {member.email}
                </td>
                <td className='staff-control-cell resend-activation-cell'>
                        {this.renderResendActivationButton(member)}
                        <IconContainer
                            icon="trash"
                            className="delete-staff-member-icon"
                            onClick={this.onRemoveButtonClick(member.id)}
                            title={_.get(this.props.translation, sharedLabelsPath.remove_button)}
                        />
                </td>
            </tr>
        ))
    }

    renderResendActivationButton(member) {
        if (member.active) {
            return null;
        }
        return (
            <Button className="btn-sm" color="link"
                    onClick={this.onResendActivationClick(member.email)}>
                {_.get(this.props.translation, 'resend_activation.title')}
            </Button>
        );
    }

    renderButtonsBar() {
        return (
            <div className='add-staff-member-button-container olive-green'>
                <Button className='change-anchor-button'
                        onClick={this.onChangeAnchorButtonClick}>
                    {_.get(this.props.translation, 'org_staff.change_anchor.title')}
                </Button>


                <IconContainer 
                    icon='add' 
                    className='add-staff-member-button' 
                    onClick={this.onAddButtonClick}
                    title={_.get(this.props.translation, sharedLabelsPath.add_button)}
                />
            </div>
        );
    }

    componentDidMount() {
        this.props.onMount();
    }

    onAddButtonClick = () => {
        this.props.onStaffMemberAdd();
    };

    onResendActivationClick = (email) => () => {
        this.setState({resendActivationEmail: email});

        this.props.onResendActivation();
    };

    onRemoveButtonClick = (id) => () => {
        this.props.onStaffMemberRemove(id);
    };

    onChangeAnchorButtonClick = () => {
        this.props.onChangeAnchor();
    };

    onStaffRemove = () => {
        this.props.onRemove();
    };
}

const StaffMemberShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired
});

StaffList.propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.arrayOf(StaffMemberShape),
    removingMode: PropTypes.bool,
    translation: PropTypes.object.isRequired,
    onStaffMemberRemove: PropTypes.func,
    onChangeAnchor: PropTypes.func,
    onResendActivation: PropTypes.func,
    onMount: PropTypes.func,
    onRemove: PropTypes.func
};

export default StaffList;



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/staffList/StaffList.js